// @ts-nocheck
import {
  DESELECT_VOUCHER,
  FETCH_VOUCHER_FULFILLED,
  FETCH_VOUCHER_REJECTED,
} from './voucherActionTypes';

const initialState = {
  voucherDetails: null,
};

export default function voucherReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_VOUCHER_FULFILLED:
      return {
        ...state,
        voucherDetails: action.payload,
      };
    case FETCH_VOUCHER_REJECTED:
      return {
        ...state,
        voucherDetails: null,
      };
    case DESELECT_VOUCHER:
      return {
        ...state,
        voucherDetails: null,
      };
    default:
      return state;
  }
}
